import { useEffect, useState } from "react";
import { Box, Grid, Grid2, InputAdornment, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { historiqueService } from "../service/HistoriqueService";
import { RemoveRedEyeOutlined, SearchOutlined } from "@material-ui/icons";
import useToast from "../hooks/useToast";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";
import { LoadingButton } from "@mui/lab";
import { frFR } from "@mui/x-data-grid/locales";
import Menu from "./Menu";
import logo from "./logo.png";
import { useQuery } from "../hooks/useQuery";
import { useNavigate } from "react-router-dom";
import { FileDownloadSharp } from "@mui/icons-material";
import { isTokenCreatedToday } from "../helpers/TokenHelpers";
import StandardSkeletoon from "./reusable/loader/StandardSkeletoon";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import { exportToExcel } from "../helpers/ExportHelpers";
import { EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS } from "./ListCandidat";


const Admin = ({ prec_url }) => {
  const { Toast, showToast } = useToast();
  const [idsButons, setIdsButons] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtre, setFiltre] = useState({ mot: "", status: null });
  const [rowsData, setRowsData] = useState([]);
  const query = useQuery();
  const [loadingData, setLoadingData] = useState(false);
  const [postulantList, setPostulantList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let token = query.get("ref");
    if (isTokenCreatedToday(token)) {
      localStorage.setItem("CODE_ADMIN", token);
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Token non fourni ou invalide");
      navigate("/");
    }
  }, []);

  const handleDownloadExcel = (rows, columns) => {
    if (rows.length > 0) {
      exportToExcel(
        rows,
        columns,
        rows.at(0).libelle_type || "Liste des candidats",
        false
      );
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Erreur de l'exportation de données excel"
      );
    }
  };

  const handleFetchCandidatList = (id_type) => {
    handleLoadThisButton(id_type);
    historiqueService
      .getListeCandidat(id_type)
      .then((res) => {
        if (res && res.data) {
          setPostulantList(res.data);
          handleDownloadExcel(res.data, EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS);
        }
      })
      .finally(() => {
        handleUnloadThisButton(id_type);
      });
  };

  const columns = [
    { field: "description", headerName: "AMI", width: 250 },
    { field: "libelle_type", headerName: "Titre", width: 400 },
    // {
    //   field: "date_debut_publication",
    //   headerName: "Date d'envoie",
    //   width: 200,
    //   valueFormatter: (params) =>
    //     dayjs(params.value).format("DD/MM/YYYY à hh : mm"),
    // },
    {
      field: "cloture",
      headerName: "Cloturé",
      with: 150,
      valueFormatter: (params) => (params.value === "1" ? "Oui" : "Non"),
    },
    {
      field: "",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Grid>
          <LoadingButton
            loading={idsButons.includes(params.row.id_type)}
            // disabled={!params.row.file_cv}
            color="secondary"
            title="Afficher liste des postulants"
            onClick={(e) =>
              navigate(
                `/administrations/liste_candidat_externe?ref=${localStorage.getItem("CODE_ADMIN")}&id_type=${params.row.id_type}`
              )
            }
          >
            <RemoveRedEyeOutlined />
          </LoadingButton>
          <LoadingButton
            loading={idsButons.includes(params.row.id_type)}
            color="success"
            title="Telecharger tous les documents envoyés"
            onClick={(e) =>
              handleDownloadAllFiles(
                params.row.id_type,
                params.row.libelle_type
              )
            }
          >
            <FileDownloadSharp />
          </LoadingButton>
          <LoadingButton
            loading={idsButons.includes(params.row.id_type)}
            // disabled={!params.row.file_cv}
            color="primary"
            title="Exporter liste des postulant en excel"
            onClick={(e) => handleFetchCandidatList(params.row.id_type)}
          >
            <ImportExportIcon />
          </LoadingButton>
        </Grid>
      ),
    },
  ];

  const handleFilter = (filtre) => {
    if (!filtre || (!filtre.mot && !filtre.status)) {
      setRowsData(rows);
      return;
    }
    // const statusFIltered = (item) =>
    //   !filtre.status || filtre.status === ""
    //     ? true
    //     : item.cloture === filtre.status;
    const mot = filtre.mot.toLowerCase();
    setRowsData(
      rows.filter((item) =>
        Object.values(item).some(
          (val) => val && val.toString().toLowerCase().includes(mot)
        )
      )
    );
  };

  const handleLoadThisButton = (ids) => {
    setIdsButons([...idsButons, ids]);
  };

  const handleUnloadThisButton = (ids) => {
    setIdsButons(idsButons.filter((id) => id !== ids));
  };

  const handleFetchOffresList = () => {
    setLoadingData(true);
    historiqueService
      .getOffreList()
      .then((res) => {
        if (res && res.data) {
          setRows(res.data);
          setRowsData(res.data);
        }
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  const handleDownloadAllFiles = (
    id_position,
    file_name = "Documents envoyés"
  ) => {
    handleLoadThisButton(id_position);
    historiqueService
      .downloadAllDocByIdPosition(id_position)
      .then((response) => {
        if (response.status !== 200) {
          showToast(TYPE_NOTIFICATION.ERROR, "Echec de telechargement");
          handleLoadThisButton(false);
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${file_name || "Document de tous les candidats"} .zip`
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
      })
      .finally(() => {
        handleUnloadThisButton(id_position);
      });
  };

  const handleDownload = (ref, file_name) => {
    handleLoadThisButton(ref);
    historiqueService
      .downloadCV(ref)
      .then((res) => {
        if (res) {
          console.log(res);

          if (res.status !== 200) {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `CV_${file_name || new Date().toLocaleString()}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          }
        }
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
      })
      .finally(() => {
        handleUnloadThisButton(ref);
      });
  };

  useEffect(() => {
    if (filtre) {
      handleFilter(filtre);
    }
  }, [filtre]);

  useEffect(() => {
    handleFetchOffresList();
  }, []);

  return (
    <Grid container style={{ display: "flex", justifyContent: "center" }}>
      <Menu />
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <Grid container justifyContent={"center"}>
          <img
            src={logo}
            className="App-logo"
            alt="logo"
            style={{
              maxWidth: "75px",
              maxHeight: "75px",
              // marginLeft: "40%",
              // display: window.innerWidth <= 600 ? "block" : "none",
            }}
          />
        </Grid>
        <Grid item>
          <Grid textAlign={"center"} width={"100%"}>
            <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
              Offres d'emplois externe
            </h1>
          </Grid>
          <Toast />
          <Box height={"100%"}>
            <Grid
              item
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
            >
              <Grid
                container
                spacing={1}
                textAlign={"center"}
                display={"flex"}
                m={1}
                width={"100%"}
              >
                <Grid item flexGrow={1}>
                  <TextField
                    id="recherche"
                    size="small"
                    fullWidth
                    onChange={(e) =>
                      setFiltre({ ...filtre, mot: e.target.value })
                    }
                    placeholder="Recherche"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchOutlined />
                          </InputAdornment>
                        ),
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid2
              // p={{ xs: 1, lg: 5 }}
              maxWidth={"98vw"}
              height="60vh"
              flexGrow={1}
            >
              <StandardSkeletoon col={3} row={8} show={loadingData} />
              <DataGrid
                columns={columns}
                rows={rowsData}
                sx={{ height: "70%", display: loadingData ? "none" : "" }}
                getRowId={(row) => row.id_type}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                hideFooter
              />
            </Grid2>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Admin;
